<template>
  <div class="scaner" ref="scaner" v-show="show">
    <div class="banner" v-if="showBanner">
      <p class="text">
        <i class="el-icon-close" @click="() => showBanner = false"></i>
        若当前浏览器无法扫码，请切换其他浏览器尝试
      </p>
    </div>
    <i class="el-icon-error close" @click="close()"></i>
    <div class="cover">
      <p v-if="continuous" class="continuous">
        连续扫码模式，需要手动关闭
      </p>
      <p class="line"></p>
      <span class="square top left"></span>
      <span class="square top right"></span>
      <span class="square bottom right"></span>
      <span class="square bottom left"></span>
      <p class="tips">将码放入框内，即可自动扫描</p>
    </div>
    <video
      class="source"
      ref="video"
      id="scanVideo"
      :width="videoWidth"
      :height="videoHeight"
    ></video>
    <audio ref="sound" :src="soundSrc"></audio>
  </div>
</template>

<script>
import { zxingScript } from '@/api.js'
export default {
  name: 'MultiScaner',
  props: {
    // 使用后置相机
    useBackCamera: {
      type: Boolean,
      default: true
    },
    // 扫描识别后停止
    stopOnScaned: {
      type: Boolean,
      default: true
    },
    drawOnfound: {
      type: Boolean,
      default: true
    },
    // 线条颜色
    lineColor: {
      type: String,
      default: '#03C03C'
    },
    // 线条宽度
    lineWidth: {
      type: Number,
      default: 2
    },
    // 视频宽度
    videoWidth: {
      type: Number,
      default: document.documentElement.clientWidth || document.body.clientWidth
    },
    // 视频高度
    videoHeight: {
      type: Number,
      default: document.documentElement.clientHeight || document.body.clientHeight
    },
    responsive: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      r: null,
      continuous: false, // 是否连续扫码
      soundSrc: `${window.location.origin}${this.$utils.siteBase()}static/images/di.mp3`,
      show: false,
      codeReader: null,
      showBanner: false,
      containerWidth: null,
      timer: null,
      timeout: 700 // 扫码间隔，连续模式下可用
    }
  },
  computed: {
    videoWH () {
      if (this.containerWidth) {
        const width = this.containerWidth;
        const height = width * 0.75;
        return { width, height };
      }

      return { width: this.videoWidth, height: this.videoHeight };
    }
  },
  methods: {
    open(r, continuous) {
      if (continuous && this.show) {
        this.r = r
        return
      }

      this.continuous = continuous
      this.r =r
      this.init()
      this.show = true
    },
    close() {
      this.show = false
      if (this.codeReader) {
        this.codeReader.reset()
        this.codeReader = null
      }
    },
    loadScript() {
      return this.$script(zxingScript)
    },
    async init() {
      // 初始化
      await this.loadScript()
      if (!window.ZXing) {
        this.init()
        return
      }

      const codeReader = new window.ZXing.BrowserMultiFormatReader()
      this.codeReader = codeReader
      codeReader.decodeFromVideoDevice(undefined, 'scanVideo', (result, err) => {
        if (result) {
          if (this.timer) {
            return
          }
          this.$refs.sound.play()
          if (this.r) {
            this.r(result.text)
          }
          if (!this.continuous) {
            this.close()
          }
          this.timer = this.timer || setTimeout(() => {
            clearTimeout(this.timer)
            this.timer = null
          }, this.timeout)
        }
        if (err && !(err instanceof window.ZXing.NotFoundException)) {
          console.error(err)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.scaner {
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 5001;
  /deep/ video {
    width: 100%;
    height: 100%;
    // object-fit: cover;
  }
  #quaggaDom {
    /deep/ canvas {
      display: none;
    }
  }
  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 30px;
    cursor: pointer;
    z-index: 10000;
    color: #fff;
  }
  .types {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 20px;
    font-size: 30px;
    cursor: pointer;
    z-index: 10000;
  }
}
.scaner .banner {
  width: 340px;
  position: absolute;
  top: 16px;
  left: 50%;
  margin-left: -170px;
  background: #FA74A2;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 12px;
  opacity: 0.9;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
}
.scaner .banner .text {
  padding: 0;
  margin: 0;
  color: #FFFFFF;
  font-size: 12px;
  text-align: justify;
  text-align-last: left;
}
.scaner .banner .close_icon {
  display: inline-block;
  height: 24px;
  width: 24px;
  /* background: url('../assets/close.png') no-repeat center; */
  background-size: auto 100%;
  position: absolute;
  right: 8px;
  top: 8px;
}
.scaner .cover {
  height: 220px;
  width: 220px;
  position: absolute;
  top:50%;
  left:50%;
  -webkit-transform: translate(-50%,-50%);
  -moz-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  -o-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
  border: .5px solid #999999;
  z-index: 998;
}
.scaner .cover .line {
  width: 200px;
  height: 1px;
  margin-left: 10px;
  background: #5F68E8;
  background: linear-gradient(to right, transparent, #5F68E8, #0165FF, #5F68E8, transparent);
  position: absolute;
  -webkit-animation: scan 1.75s infinite linear;
  -moz-animation: scan 1.75s infinite linear;
  -ms-animation: scan 1.75s infinite linear;
  -o-animation: scan 1.75s infinite linear;
  animation: scan 1.75s infinite linear;
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -ms-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  border-radius: 1px;
}
.scaner .cover .square {
  display: inline-block;
  height: 20px;
  width: 20px;
  position: absolute;
}
.scaner .cover .square.top {
  top: 0;
  border-top: 1px solid #5F68E8;
}
.scaner .cover .square.left {
  left: 0;
  border-left: 1px solid #5F68E8;
}
.scaner .cover .square.bottom {
  bottom: 0;
  border-bottom: 1px solid #5F68E8;
}
.scaner .cover .square.right {
 right: 0;
  border-right: 1px solid #5F68E8;
}
.scaner .cover .tips {
  position: absolute;
  bottom: -48px;
  width: 100%;
  font-size: 14px;
  color: #FFFFFF;
  opacity: 0.8;
  text-align: center;
}
.scaner .cover .continuous {
  position: absolute;
  top: -48px;
  width: 100%;
  font-size: 14px;
  color: #FFFFFF;
  opacity: 0.8;
  text-align: center;
}
@-webkit-keyframes scan {
  0% {top: 0}
  25% {top: 50px}
  50% {top: 100px}
  75% {top: 150px}
  100% {top: 200px}
}
@-moz-keyframes scan {
  0% {top: 0}
  25% {top: 50px}
  50% {top: 100px}
  75% {top: 150px}
  100% {top: 200px}
}
@-o-keyframes scan {
  0% {top: 0}
  25% {top: 50px}
  50% {top: 100px}
  75% {top: 150px}
  100% {top: 200px}
}
@keyframes scan {
  0% {top: 0}
  25% {top: 50px}
  50% {top: 100px}
  75% {top: 150px}
  100% {top: 200px}
}
</style>